import css from './style.module.scss';
import { gql } from '../../util/fetchGql';
import Wrap from '../Wrap';
import A from '../A';
import Image from 'next/image';

export const AWARDS_PRODUCT_FRAGMENT = gql`
	fragment AwardsProduct on productContent_awards_BlockType {
		awards {
			... on awards_BlockType {
				id
				image {
					title
					width
					height
					url
				}
				linkUrl
			}
		}
	}
`;

export default function Awards ({ awards }) {
	return (
		<Wrap className={css.awardsWrap}>
			<div className={css.awards}>
				<h4>Awards & Accolades</h4>
				<div>
					{(awards ?? []).map((award, i) => award.linkUrl ? (
						<A href={award.linkUrl} target="_blank" rel="noopener noreferrer" key={i}>
							<Image unoptimized
								src={award.image[0].url}
								width={200}
								height={160}
								alt={award.image[0].title}
							/>
						</A>
					) : (
						<span key={i}>
							<Image unoptimized
								src={award.image[0].url}
								width={200}
								height={160}
								alt={award.image[0].title}
							/>
						</span>
					))}
				</div>
			</div>
		</Wrap>
	);
}
